export const additionalEnglishContent = {
  personal_disagreeList: [
    {
      value: "owner_dob_mismatch",
      label: "Owner DOB Mismatch",
      checked: false,
    },
    {
      value: "owner_name_mismatch",
      label: "Owner Name Mismatch",
      checked: false,
    },
    { value: "address_mismatch", label: "Address Mismatch", checked: false },
    {
      value: "insured_dob_mismatch",
      label: "Insured DOB Mismatch",
      checked: false,
    },
    { value: "nominee_mismatch", label: "Nominee Mismatch", checked: false },
    {
      value: "insured_name_mismatch",
      label: "Insured Name Mismatch",
      checked: false,
    },
    {
      value: "emailid_is_incorrect",
      label: "Email id is incorrect",
      checked: false,
    },
  ],
  policy_disagreeList: [
    {
      value: "different_product_required",
      label: "Different product required",
      checked: false,
    },
    {
      value: "Payment frequency is different",
      label: "Payment frequency is different",
      checked: false,
    },
    {
      value: "policy_term_is_different",
      label: "Policy term is different",
      checked: false,
    },
    {
      value: "pay_term_is_different",
      label: "Pay term is different",
      checked: false,
    },
    {
      value: "risk_cover/sum_assured_different",
      label: "Risk cover/sum assured different",
      checked: false,
    },
    {
      value: "want_to_cancel",
      label: "Want to cancel",
      checked: false,
    },
    {
      value: "not_happy_with_the_plan_features",
      label: "Not happy with the plan features",
      checked: false,
    },
    {
      value: "financial_problem",
      label: "Financial problem",
      checked: false,
    },
    {
      value: "others",
      label: "Others",
      checked: false,
    },
    {
      value: "wrong_commitment",
      label: "Wrong Commitment",
      checked: false,
    },
  ],
};

export const additionalHindiContent = {
  personal_disagreeList: [
    {
      value: "owner_dob_mismatch",
      label: "ओनर का जन्मदिन गलत",
      checked: false,
    },
    {
      value: "owner_name_mismatch",
      label: "ओनर का नाम गलत",
      checked: false,
    },
    { value: "address_mismatch", label: "पता गलत", checked: false },
    {
      value: "insured_dob_mismatch",
      label: "इंसुरेड का जन्मदिन गलत",
      checked: false,
    },
    { value: "nominee_mismatch", label: "नॉमिनी गलत", checked: false },
    {
      value: "insured_name_mismatch",
      label: "इंसुरेड का नाम गलत है",
      checked: false,
    },
    {
      value: "emailid_is_incorrect",
      label: "ईमेल गलत है ",
      checked: false,
    },
  ],
  policy_disagreeList: [
    {
      value: "different_product_required",
      label: "अलग प्रोडक्ट चाहिए",
      checked: false,
    },
    {
      value: "Payment frequency is different",
      label: "पेमेंट फ्रीक्वेंसी अलग है",
      checked: false,
    },
    {
      value: "policy_term_is_different",
      label: "पालिसी टर्म अलग है",
      checked: false,
    },
    {
      value: "pay_term_is_different",
      label: "पेय टर्म अलग है",
      checked: false,
    },
    {
      value: "risk_cover/sum_assured_different",
      label: "रिस्क कवर/सम एश्योर्ड अलग",
      checked: false,
    },
    {
      value: "want_to_cancel",
      label: "कैंसिल करना चाहते हैं",
      checked: false,
    },
    {
      value: "not_happy_with_the_plan_features",
      label: "प्लान फीचर के साथ नाखुश",
      checked: false,
    },
    {
      value: "financial_problem",
      label: "फाइनेंसियल प्रॉब्लम",
      checked: false,
    },
    {
      value: "others",
      label: "अन्य",
      checked: false,
    },
    {
      value: "wrong_commitment",
      label: "गलत कमिटमेंट",
      checked: false,
    },
  ],
};

export const additionalPunjabiContent = {
  personal_disagreeList: [
    {
      value: "owner_dob_mismatch",
      label: "ਮਾਲਕ DOB ਬੇਮੇਲ ਹੈ",
      checked: false,
    },
    {
      value: "owner_name_mismatch",
      label: "ਮਾਲਕ ਦਾ ਨਾਮ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ",
      checked: false,
    },
    { value: "address_mismatch", label: "ਪਤਾ ਬੇਮੇਲ", checked: false },
    {
      value: "insured_dob_mismatch",
      label: "ਬੀਮਾਯੁਕਤ DOB ਬੇਮੇਲ ਹੈ",
      checked: false,
    },
    { value: "nominee_mismatch", label: "ਨਾਮਜ਼ਦ ਬੇਮੇਲ", checked: false },
    {
      value: "insured_name_mismatch",
      label: "ਬੀਮਾਯੁਕਤ ਨਾਮ ਬੇਮੇਲ ਹੈ",
      checked: false,
    },
    {
      value: "emailid_is_incorrect",
      label: "ਈਮੇਲ ਆਈਡੀ ਗਲਤ ਹੈ",
      checked: false,
    },
  ],
  policy_disagreeList: [
    {
      value: "different_product_required",
      label: "ਵੱਖ-ਵੱਖ ਉਤਪਾਦ ਦੀ ਲੋੜ ਹੈ",
      checked: false,
    },
    {
      value: "Payment frequency is different",
      label: "ਭੁਗਤਾਨ ਦੀ ਬਾਰੰਬਾਰਤਾ ਵੱਖਰੀ ਹੈ",
      checked: false,
    },
    {
      value: "policy_term_is_different",
      label: "ਪਾਲਿਸੀ ਦੀ ਮਿਆਦ ਵੱਖਰੀ ਹੈ",
      checked: false,
    },
    {
      value: "pay_term_is_different",
      label: "ਤਨਖਾਹ ਦੀ ਮਿਆਦ ਵੱਖਰੀ ਹੈ",
      checked: false,
    },
    {
      value: "risk_cover/sum_assured_different",
      label: "ਜੋਖਮ ਕਵਰ/ ਬੀਮੇ ਦੀ ਰਕਮ ਵੱਖਰੀ",
      checked: false,
    },
    {
      value: "want_to_cancel",
      label: "ਰੱਦ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹਨ",
      checked: false,
    },
    {
      value: "not_happy_with_the_plan_features",
      label: "ਪਲਾਨ ਦੀਆਂ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਤੋਂ ਖੁਸ਼ ਨਹੀਂ",
      checked: false,
    },
    {
      value: "financial_problem",
      label: "ਵਿੱਤੀ ਸਮੱਸਿਆ",
      checked: false,
    },
    {
      value: "others",
      label: "ਹੋਰ",
      checked: false,
    },
    {
      value: "wrong_commitment",
      label: "ਗਲਤ ਵਚਨਬੱਧਤਾ",
      checked: false,
    },
  ],
};

export const additionalGujratiContent = {
  personal_disagreeList: [
    {
      value: "owner_dob_mismatch",
      label: "માલિક DOB મેળ ખાતો નથી",
      checked: false,
    },
    {
      value: "owner_name_mismatch",
      label: "માલિકનું નામ મેળ ખાતું નથી",
      checked: false,
    },
    { value: "address_mismatch", label: "સરનામું મેળ ખાતું નથી", checked: false },
    {
      value: "insured_dob_mismatch",
      label: "વીમેદાર DOB મેળ ખાતો નથી",
      checked: false,
    },
    { value: "nominee_mismatch", label: "નોમિની મિસમેચ", checked: false },
    {
      value: "insured_name_mismatch",
      label: "વીમાધારકનું નામ મેળ ખાતું નથી",
      checked: false,
    },
    {
      value: "emailid_is_incorrect",
      label: "ઈમેલ આઈડી ખોટો છે",
      checked: false,
    },
  ],
  policy_disagreeList: [
    {
      value: "different_product_required",
      label: "વિવિધ ઉત્પાદન જરૂરી",
      checked: false,
    },
    {
      value: "Payment frequency is different",
      label: "ચુકવણી આવર્તન અલગ છે",
      checked: false,
    },
    {
      value: "policy_term_is_different",
      label: "પોલિસીની મુદત અલગ છે",
      checked: false,
    },
    {
      value: "pay_term_is_different",
      label: "પગારની મુદત અલગ છે",
      checked: false,
    },
    {
      value: "risk_cover/sum_assured_different",
      label: "જોખમ કવર/સમ એશ્યોર્ડ અલગ",
      checked: false,
    },
    {
      value: "want_to_cancel",
      label: "રદ કરવા માંગો છો",
      checked: false,
    },
    {
      value: "not_happy_with_the_plan_features",
      label: "યોજનાની વિશેષતાઓથી ખુશ નથી",
      checked: false,
    },
    {
      value: "financial_problem",
      label: "નાણાકીય સમસ્યા",
      checked: false,
    },
    {
      value: "others",
      label: "અન્ય",
      checked: false,
    },
    {
      value: "wrong_commitment",
      label: "ખોટી પ્રતિબદ્ધતા",
      checked: false,
    },
  ],
};

export const additionalTeleguContent = {
  personal_disagreeList: [
    {
      value: "owner_dob_mismatch",
      label: "యజమాని DOB సరిపోలలేదు",
      checked: false,
    },
    {
      value: "owner_name_mismatch",
      label: "యజమాని పేరు సరిపోలలేదు",
      checked: false,
    },
    { value: "address_mismatch", label: "చిరునామా సరిపోలలేదు", checked: false },
    {
      value: "insured_dob_mismatch",
      label: "బీమా చేయబడిన DOB సరిపోలలేదు",
      checked: false,
    },
    { value: "nominee_mismatch", label: "నామినీ సరిపోలలేదు", checked: false },
    {
      value: "insured_name_mismatch",
      label: "బీమా చేయబడిన పేరు సరిపోలలేదు",
      checked: false,
    },
    {
      value: "emailid_is_incorrect",
      label: "ఇమెయిల్ ఐడి తప్పు",
      checked: false,
    },
  ],
  policy_disagreeList: [
    {
      value: "different_product_required",
      label: "వివిధ ఉత్పత్తి అవసరం",
      checked: false,
    },
    {
      value: "Payment frequency is different",
      label: "చెల్లింపు ఫ్రీక్వెన్సీ భిన్నంగా ఉంటుంది",
      checked: false,
    },
    {
      value: "policy_term_is_different",
      label: "పాలసీ టర్మ్ భిన్నంగా ఉంటుంది",
      checked: false,
    },
    {
      value: "pay_term_is_different",
      label: "చెల్లింపు వ్యవధి భిన్నంగా ఉంటుంది",
      checked: false,
    },
    {
      value: "risk_cover/sum_assured_different",
      label: "రిస్క్ కవర్/సమ్ హామీ వేర్వేరు",
      checked: false,
    },
    {
      value: "want_to_cancel",
      label: "రద్దు చేయాలన్నారు",
      checked: false,
    },
    {
      value: "not_happy_with_the_plan_features",
      label: "ప్లాన్ ఫీచర్లతో సంతోషంగా లేదు",
      checked: false,
    },
    {
      value: "financial_problem",
      label: "ఆర్థిక సమస్య",
      checked: false,
    },
    {
      value: "others",
      label: "ఇతరులు",
      checked: false,
    },
    {
      value: "wrong_commitment",
      label: "రాంగ్ కమిట్మెంట్",
      checked: false,
    },
  ],
};

export const additionalKannadaContent = {
  personal_disagreeList: [
    {
      value: "owner_dob_mismatch",
      label: "ಮಾಲೀಕರು DOB ಹೊಂದಿಕೆಯಾಗುವುದಿಲ್ಲ",
      checked: false,
    },
    {
      value: "owner_name_mismatch",
      label: "ಮಾಲೀಕರ ಹೆಸರು ಹೊಂದಾಣಿಕೆಯಾಗುತ್ತಿಲ್ಲ",
      checked: false,
    },
    { value: "address_mismatch", label: "ವಿಳಾಸ ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ", checked: false },
    {
      value: "insured_dob_mismatch",
      label: "ವಿಮೆ ಮಾಡಲಾದ DOB ಹೊಂದಿಕೆಯಾಗುವುದಿಲ್ಲ",
      checked: false,
    },
    { value: "nominee_mismatch", label: "ನಾಮಿನಿ ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ", checked: false },
    {
      value: "insured_name_mismatch",
      label: "ವಿಮೆ ಮಾಡಿದ ಹೆಸರು ಹೊಂದಿಕೆಯಾಗುವುದಿಲ್ಲ",
      checked: false,
    },
    {
      value: "emailid_is_incorrect",
      label: "ಇಮೇಲ್ ಐಡಿ ತಪ್ಪಾಗಿದೆ",
      checked: false,
    },
  ],
  policy_disagreeList: [
    {
      value: "different_product_required",
      label: "ವಿಭಿನ್ನ ಉತ್ಪನ್ನ ಅಗತ್ಯವಿದೆ",
      checked: false,
    },
    {
      value: "Payment frequency is different",
      label: "ಪಾವತಿ ಆವರ್ತನ ವಿಭಿನ್ನವಾಗಿದೆ",
      checked: false,
    },
    {
      value: "policy_term_is_different",
      label: "ನೀತಿಯ ಅವಧಿಯು ವಿಭಿನ್ನವಾಗಿದೆ",
      checked: false,
    },
    {
      value: "pay_term_is_different",
      label: "ಪಾವತಿ ಅವಧಿಯು ವಿಭಿನ್ನವಾಗಿದೆ",
      checked: false,
    },
    {
      value: "risk_cover/sum_assured_different",
      label: "ಅಪಾಯದ ಕವರ್/ವಿಶ್ವಾಸಿತ ಮೊತ್ತ ವಿಭಿನ್ನವಾಗಿದೆ",
      checked: false,
    },
    {
      value: "want_to_cancel",
      label: "ರದ್ದು ಮಾಡಲು ಬಯಸುತ್ತಾರೆ",
      checked: false,
    },
    {
      value: "not_happy_with_the_plan_features",
      label: "ಯೋಜನೆಯ ವೈಶಿಷ್ಟ್ಯಗಳೊಂದಿಗೆ ಸಂತೋಷವಾಗಿಲ್ಲ",
      checked: false,
    },
    {
      value: "financial_problem",
      label: "ಹಣಕಾಸಿನ ಸಮಸ್ಯೆ",
      checked: false,
    },
    {
      value: "others",
      label: "ಇತರರು",
      checked: false,
    },
    {
      value: "wrong_commitment",
      label: "ತಪ್ಪು ಬದ್ಧತೆ",
      checked: false,
    },
  ],
};
export const additionalTamilContent = {
  personal_disagreeList: [
    {
      value: "owner_dob_mismatch",
      label: "உரிமையாளர் பிறந்த தேதி பொருந்தவில்லை",
      checked: false,
    },
    {
      value: "owner_name_mismatch",
      label: "உரிமையாளர் பெயர் பொருந்தவில்லை",
      checked: false,
    },
    { value: "address_mismatch", label: "Address Mismatch", checked: false },
    {
      value: "insured_dob_mismatch",
      label: "காப்பீடு செய்யப்பட்ட பிறந்த தேதி பொருந்தவில்லை",
      checked: false,
    },
    { value: "nominee_mismatch", label: "Nominee Mismatch", checked: false },
    {
      value: "insured_name_mismatch",
      label: "உறுதி செய்யப்பட்ட பெயர் பொருந்தவில்லை",
      checked: false,
    },
    {
      value: "emailid_is_incorrect",
      label: "மின்னஞ்சல் ஐடி தவறானது",
      checked: false,
    },
  ],
  policy_disagreeList: [
    {
      value: "different_product_required",
      label: "வேறு product தேவை",
      checked: false,
    },
    {
      value: "Payment frequency is different",
      label: "கட்டண தவணைக்கூறு வேறுபட்டுள்ளது",
      checked: false,
    },
    {
      value: "policy_term_is_different",
      label: "கொள்கை காலம் வேறுபட்டுள்ளது",
      checked: false,
    },
    {
      value: "pay_term_is_different",
      label: "செலுத்தும் காலம் வேறுபட்டுள்ளது",
      checked: false,
    },
    {
      value: "risk_cover/sum_assured_different",
      label: "ரிஸ்க் கவர்/உறுதிப்படுத்தப்பட்ட தொகை வேறுபட்டுள்ளது",
      checked: false,
    },
    {
      value: "want_to_cancel",
      label: "ரத்து செய்ய வேண்டும்",
      checked: false,
    },
    {
      value: "not_happy_with_the_plan_features",
      label: "திட்ட அம்சங்களில் திருப்தி இல்லை",
      checked: false,
    },
    {
      value: "financial_problem",
      label: "நிதி பிரச்சனைகள்",
      checked: false,
    },
    {
      value: "others",
      label: "மற்றவைகள்",
      checked: false,
    },
    {
      value: "wrong_commitment",
      label: "தவறான அர்ப்பணிப்பு",
      checked: false,
    },
  ],
};